import { getPrePacksPrefix, goToTab, moveTabs } from "../../../../components/helpers";
import * as React from "react";
import { SideArrow } from "../SideArrow";
import { debounce } from "debounce-decorator";
export class FiltersWeb extends React.Component {
    constructor() {
        super(...arguments);
        this.baseClassName = getPrePacksPrefix("filters");
        this.filters = React.createRef();
        this.innerFilters = React.createRef();
        this.state = {
            hasRightArrow: false,
            hasLeftArrow: false
        };
        this.handleAnimation = (filter) => {
            if (this.filters.current && this.innerFilters.current) {
                goToTab({
                    tab: filter,
                    tabs: this.filters.current,
                    wrapper: this.innerFilters.current,
                    onComplete: this.toggleArrows
                });
            }
        };
        this.toggleArrows = () => {
            if (this.filters.current && this.innerFilters.current) {
                const tabsRect = this.filters.current.getBoundingClientRect();
                const wrapperRect = this.innerFilters.current.getBoundingClientRect();
                this.setState({
                    hasRightArrow: Math.floor(tabsRect.right) > wrapperRect.right,
                    hasLeftArrow: Math.ceil(tabsRect.left) < wrapperRect.left
                });
            }
        };
        this.handleArrowClick = (direction) => {
            if (this.innerFilters.current && this.filters.current) {
                const { step, duration, ease } = this.props.tabsAnimation;
                moveTabs({
                    direction,
                    step,
                    tabs: this.filters.current,
                    wrapper: this.innerFilters.current,
                    tabsAnimation: { duration, ease },
                    onComplete: this.toggleArrows,
                });
            }
        };
        this.buildFilter = (filters) => {
            const { filterComponent: Filter } = this.props;
            return filters.map(f => {
                const filterProps = Object.assign(Object.assign({}, f), { handleAnimation: this.handleAnimation });
                return React.createElement(Filter, Object.assign({}, filterProps, { key: `filter-key-${f.id}` }));
            });
        };
        this.debouncedOnResizeHandler = debounce(this.toggleArrows, 50);
        this.toggleArrowsRafId = 0;
    }
    componentDidMount() {
        this.toggleArrowsRafId = requestAnimationFrame(this.toggleArrows);
        window.addEventListener("resize", this.debouncedOnResizeHandler);
    }
    componentWillUnmount() {
        cancelAnimationFrame(this.toggleArrowsRafId);
        window.removeEventListener("resize", this.debouncedOnResizeHandler);
    }
    render() {
        return React.createElement("div", { className: `${this.baseClassName}-wrapper`, "data-testid": "wrapper-prepacks-filters" },
            this.state.hasLeftArrow && React.createElement(SideArrow, { direction: "left", onClick: this.handleArrowClick }),
            this.state.hasRightArrow && React.createElement(SideArrow, { direction: "right", onClick: this.handleArrowClick }),
            React.createElement("div", { className: `${this.baseClassName}-inner`, "data-testid": "inner-prepacks-filters", "aria-label": "Pre Packs filters", ref: this.innerFilters },
                React.createElement("div", { className: this.baseClassName, "data-testid": "prepacks-filters", role: "tablist", "aria-label": "Pre Packs filters", ref: this.filters }, this.buildFilter(this.props.filters))));
    }
}
//# sourceMappingURL=FiltersWeb.js.map